import { TransactionHistoryType } from "redux/actions/actionType";

// get Transaction form Data
export const transactionAction = (data) => {
  return {
    type: TransactionHistoryType.getTransactionHistory,
    payload: data,
  };
};
// get Transaction pageNumber
export const transactionPageNumber = (data) => {
  return {
    type: TransactionHistoryType.getTransactionPageNum,
    payload: data,
  };
};

// transactionSettingListAct
export const transactionSettingListAct = (data) => {
  return {
    type: TransactionHistoryType.getTransactionSettingList,
    payload: data,
  };
};

// transactionSettingListAct
export const transactionOrderChangeAct = (data) => {
  return {
    type: TransactionHistoryType.getTransactionOrderChange,
    payload: data,
  };
};
